angular.module('moebiusProadapt').controller('ctrlUtilisateursIndex',
    ['$timeout','$rootScope', '$scope', '$http', '$location', 'utilisateursResolver', '$uibModal', 'promiseTracker', function($timeout,$rootScope, $scope, $http, $location, utilisateursResolver, $uibModal, promiseTracker){


        $scope.centres = utilisateursResolver.centres;
        $scope.users            = utilisateursResolver.users;
        $scope.tracker      = promiseTracker('tracker');

        $scope.openModalUser = function (user) {
            //le role doit être au format chaine de caractères pour remplir le menu déroulant
            if(user.role) {
                user.role = user.role+"";
            }

            var isNewUser = _.isEmpty(user);

            var scopeModal = $scope.$new();

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/utilisateurs/modal-add-user.html',
                controller: 'ctrlUtilisateursAddUser',
                windowClass: 'md-dialog',
                scope: scopeModal,
                backdrop: 'static',
                resolve: {
                    user: angular.copy(user)
                }
            });

            console.log('is existing ?', )

            var promise = modalInstance.result;
            var promiseFullClosed = modalInstance.closed;

            $scope.tracker.addPromise(promise);

            promise.then(function (item) {
                // si action cancelled
                if (!item) {
                    return;
                }
                if(isNewUser){
                    $scope.users.unshift(item);
                }else{
                    $scope.users[_.findIndex($scope.users, { id: item.id })] = item;
                }
            });
        };

        //at form validation, send its data to back to create a new user
        $scope.desactivateUser = function(user) {

            return $http.post('desactivate', user)
                .then(function(r) {
                    if(r.data.deleted_at !== null) {
                        let indexC = _.findIndex($scope.centres, { id: r.data.centre_id });
                        let indexU = _.findIndex($scope.centres[indexC], { id: r.data.id });
                        $scope.centres[indexC].users.splice(indexU, 1);
                    }
                    $scope.$close(r.data);
                });
        }
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/utilisateurs/utilisateursIndex.js